<div class="modal-header">
    <div
        class="modal-title h4"
        role="heading"
        aria-level="1"
    >
        {{ i18n._112_CHANGE_SECURITY_QUESTION | translate }}
    </div>
    <button
        type="button"
        class="close"
        [attr.aria-label]="i18n._763_CLOSE | translate"
        (click)="activeModal.dismiss()"
    >
        <cmps-icon svgIcon="close"></cmps-icon>
    </button>
</div>
<div class="modal-body">
    <cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
    <div
        class="alert alert-warning"
        role="alert"
        *ngIf="!hasPendingData && model == null"
    >
        {{
            i18n._812_UNABLE_TO_RETRIEVE_YOUR_CURRENT_SECURITY_QUESTION_
                | translate
        }}
    </div>
    <div
        class="container-fluid"
        *ngIf="!hasPendingData && model != null"
    >
        <form
            [name]="form.name"
            #securityQuestionNgForm="ngForm"
        >
            <div class="row">
                <div class="col-12 form-group">
                    <label>{{
                        form.fields.SECURITY_QUESTION.label | translate
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        [name]="form.fields.SECURITY_QUESTION.name"
                        [placeholder]="
                            form.fields.SECURITY_QUESTION.placeholder
                                | translate
                        "
                        [(ngModel)]="model.question"
                        [field]="form.fields.SECURITY_QUESTION"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.SECURITY_QUESTION"
                    >
                        {{ form.errors.SECURITY_QUESTION }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 form-group">
                    <label>{{ form.fields.ANSWER.label | translate }}</label>
                    <input
                        type="text"
                        class="form-control"
                        [name]="form.fields.ANSWER.name"
                        [placeholder]="
                            form.fields.ANSWER.placeholder | translate
                        "
                        [(ngModel)]="model.answer"
                        [field]="form.fields.ANSWER"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.ANSWER"
                    >
                        {{ form.errors.ANSWER }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div
                        class="alert alert-warning"
                        role="alert"
                        *ngIf="failure"
                    >
                        <strong>{{
                            i18n._813_SECURITY_QUESTION_AND_ANSWER_CHANGE_FAILED_
                                | translate
                        }}</strong>
                        {{
                            form.serverError ||
                                (i18n._814_COMPAS_WAS_UNABLE_TO_CHANGE_YOUR_SECURITY_QUESTION_AND_ANSWER__PLEASE_TRY_AGAIN_
                                    | translate)
                        }}
                    </div>
                    <div
                        class="alert alert-success"
                        role="alert"
                        *ngIf="success"
                    >
                        <strong>{{
                            i18n._815_SECURITY_QUESTION_AND_ANSWER_CHANGE_SUCCESSFUL_
                                | translate
                        }}</strong>
                        {{
                            i18n._816_YOUR_SECURITY_QUESTION_AND_ANSWER_HAVE_BEEN_CHANGED_
                                | translate
                        }}
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!success; else successTpl">
        <button
            type="button"
            class="btn btn-secondary"
            (click)="activeModal.dismiss()"
        >
            {{ i18n._121_CANCEL | translate }}
        </button>
        <button
            type="button"
            class="btn btn-primary"
            (click)="onSubmit()"
            [disabled]="form.submitted"
            *ngIf="!hasPendingData && model != null"
        >
            {{ i18n._705_UPDATE | translate }}
        </button>
    </ng-container>
    <ng-template #successTpl>
        <button
            type="button"
            class="btn btn-primary"
            (click)="activeModal.close()"
        >
            {{ i18n._637_OKAY | translate }}
        </button>
    </ng-template>
</div>
